<template>
  <span
    :data-testid="sectionTag"
    class="w-dot-indicator"
    :class="{ [status]: !color, pulse }"
    :style="color ? { backgroundColor: color } : undefined"
  />
</template>

<script setup lang="ts">
import { tokens } from '@/plugins/vuetify'

export interface WDotIndicatorProps {
  sectionTag?: string
  status?: 'active' | 'inactive' | 'pending' | 'error'
  color?: string
  pulse?: boolean
}

withDefaults(defineProps<WDotIndicatorProps>(), {
  sectionTag: 'unspecified',
  status: 'active',
  pulse: false,
})

</script>

<style scoped>
.w-dot-indicator {
  display: inline-block;
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.w-dot-indicator.active {
  background-color: v-bind('tokens.color.status.success.icon');
}

.w-dot-indicator.error {
  background-color: v-bind('tokens.color.status.danger.icon');
}

.w-dot-indicator.inactive {
  background-color: v-bind('tokens.color.status.neutral.surface_muted');
}

.w-dot-indicator.pending {
  background-color: v-bind('tokens.color.status.warning.icon');
}

.w-dot-indicator.pulse {
  animation: dot-pulse 1.5s ease-in-out infinite;
}

@keyframes dot-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}
</style>
